import { createStore } from 'vuex'
import api from '../api'

export default createStore({
  state: {
    user: {
      token: localStorage.getItem('token') || '',
      info: JSON.parse(localStorage.getItem('userInfo') || 'null')
    }
  },
  mutations: {
    SET_TOKEN (state, token) {
      state.user.token = token
      localStorage.setItem('token', token)
      if (token) {
        api.defaults.headers.common.Authorization = `Bearer ${token}`
      } else {
        delete api.defaults.headers.common.Authorization
      }
    },
    SET_USER_INFO (state, userInfo) {
      state.user.info = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    LOGOUT (state) {
      state.user.token = ''
      state.user.info = null
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      delete api.defaults.headers.common.Authorization
    }
  },
  actions: {
    login ({ commit }, { token, user }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', user)
    },
    logout ({ commit }) {
      commit('LOGOUT')
    }
  },
  getters: {
    isAuthenticated: state => !!state.user.token,
    userRole: state => state.user.info?.role || ''
  }
})
